import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IInvoice extends BaseEntity {
    name: string;
    totalAmount: number;
    lines: IInvoiceLine[];
    hasUnpaid: boolean = false;
    twinfieldNumber: number;
}

export class IInvoiceLine extends BaseEntity {
    description: string;
    count: number;
    amountPerUnit: number;
    totalAmount: number;
}

export class InvoicesService extends BaseService<IInvoice> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'finance/invoice');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/invoices.service.ts